//Quick View

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function () {
// cart
    var cart_item_qty = '';
      var varid = '';
    var varqty = '';
//     default
    var vid_default= '';
    var changed_varient_id='';
    fetch('/cart.js',{
    })
    .then((get_res)=>{
      return get_res.json();
    })
    .then((new_get_res)=>{
      //       	console.log(new_get_res);
      console.log(new_get_res);

      cart_item_qty = new_get_res.items;
      for(let i=0; i<cart_item_qty.length; i++ ){
        varqty = cart_item_qty[i].quantity;
        varid = cart_item_qty[i].id;
      	console.log(varid +'cartid');
        console.log(varqty + 'cartqty');
        
      }
      
//     console.log(new_get_res.items);
    })
    
    
   
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      console.log(product);

      
      
      var title = product.title;
      var type = product.type;
      var price = product.price/100;
      var original_price = product.compare_at_price/100;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      $('.qv-product-title').text(title);
      if(original_price ){
      $('.qv-product-original-price').text(`RS. ${original_price}`);
      }
      $('.qv-product-price').text(`RS. ${price}`);
      $('.qv-product-type').text(type);
      $(product.tags).each(function (i,tag) {
        if(tag =='Pre Order'){
          console.log("product-Tag",tag,i);

          // $('.qv-product-pre-order-des').text("This product is available on pre order");
          $('.qv-add-button').val("pre order");
        }
      });
      $('.qv-product-description').html(desc);
      $('.view-product').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);

          $('.qv-product-images').slick({
            'dots': false,
            'arrows': false,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');

        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      
      $(options).each(function (i, option) {
      
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });

//       $(product.variants).each(function (i, v) {
//         console.log("--->",v);
//         console.log(v.id +'varient id');
        
//         vid_default = v.id;
//         console.log(vid_default +'/////////////default varient id');
//         if (v.inventory_policy == 'deny') {
//           $('.qv-add-button').prop('disabled', true).val('Sold Out');
//           $('.qv-add-to-cart').hide();
//           $('.qv-product-price').text('Sold Out').show();
//           return true
//         } else {
//           price = parseFloat(v.price / 100).toFixed(2);
//           original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
//           $('.qv-product-price').text('Rs.' + price);
//           if (original_price != price) {
//             $('.qv-product-original-price').text('Rs.' + original_price).show();
//           } else {
//             $('.qv-product-original-price').hide();
//           }
//           $('select.option-0').val(v.option1);
//           $('select.option-1').val(v.option2);
//           $('select.option-2').val(v.option3);
//           return false
//         }
//       });
    });

    $(document).on("change", "#quick-view select", function (i) {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
          console.log("hello change 1",selectedOptions);

        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
          console.log("hello change 2",selectedOptions);

        }
      });
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        console.log("hello000000");
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            var v_id = v.id;
            console.log(price + 'hdhjd');
            $('.qv-product-price').text('Rs.' + price);
            $('.qv-product-original-price').text('Rs.' + original_price);
            console.log("v_inv",v_inv);
            console.log(v_id + '/////////////////////canged varient id size');
            changed_varient_id = v_id;
            if (v.inventory_policy == 'continue') {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else{
              $('.qv-add-button').prop('disabled', true).val('Sold Out');
            }
//              if (v.inventory_policy == 'deny')
//           else{
//               if (v.inventory_quantity < 1) {
//                 console.log('oko');
//                 $('.qv-add-button').prop('disabled', true).val('Sold Out');
//               } else {
//                 console.log('ok2');

//                 $('.qv-add-button').prop('disabled', false).val('Add to Cart');
//               }
//             }
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function (event) {
          
           var qty = $('.qv-quantity').val();
         
         
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                console.log(var_id);
                
                var obj = {
                  id: var_id,
                  quantity: parseInt(qty)
                };
                
                
                
                var isFlag = false;
          
          console.log(obj.id,obj.quantity);
          console.log("---------ok");
          fetch('/cart.js', {
            method: 'GET'
          })
          .then(response => response.json())
          .then(result => {
            console.log('Success:', result.items);
            console.log('Success:', result.item_count);
	
            
//             console.log("v_id------->",data);
            if (result.items.length > 0)
            {
              $(result.items).each(function(index, value) {
                debugger;
                let qty = value.quantity + parseInt(obj.quantity);
                let v_id = parseInt(obj.id)
                console.log(qty, v_id, '--------------------------------------------')
                console.log(value.id, '--------------------------------------------')

                console.log('Success:', value.id,value.quantity);
                if(value.id == v_id)
                {
//                   alert('ID Match');
                  if (qty <= 5)
                  {
//                     alert('ID Match and QTY less then 5');
                    console.log("true");
                    isFlag = true
                  }
                  else
                  {
//                                         alert('ID Match and already 5 qty')
                    if( $(".shopify-product-form .qty-note").length > 0 ){
                    }else{
                      $(".shopify-product-form .quantity").after("<div class='qty-note'> You can not add more than 5 items.</div>")
//                       alert("You can not add more than 5 items.");
                       $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' +'Item Limit can not exceed upto 5.');
                    }
                    isFlag = false;
                  }
                  
                 	return false;
                }
                else
                {
//                   alert('ID not Match')
                  if(obj.quantity <=5){
                    console.log("---------great",obj.quantity);
                    isFlag = true;
                  }
                }
              })
            }
            else
            { 
              if(obj.quantity <=5){
              console.log("---------great",obj.quantity);
              isFlag = true;
              }
            }
            
            if (isFlag)
            {
              processCart();
            }
            
            

          })
          .catch(error => {
            console.error('Error:', error);
          });
                
                
//                 fetch('/cart.js',{
//                 })
//                 .then((get_res)=>{
//                   return get_res.json();
//                 })
//                 .then((new_get_res)=>{
//                   console.log(new_get_res);
                  
//                   let cart_items_array = new_get_res.items;
//                   console.log('hamza',cart_items_array);
                  
//                   if(cart_items_array.length == 0){
//                   	processCart()
//                     alert('HAMZA')
//                   }
                  
//                   else{
//                     for(let i=0;i<cart_items_array.length;i++){
//                       alert('cart_id ' + cart_items_array[i].id)
//                       alert('my_id ' + var_id)
//                       if(cart_items_array[i].id == var_id){
                        
//                         alert('itachi')
//                         let cart_item_qty = Number(cart_items_array[i].quantity);
//                         let new_enter_qty = Number(document.querySelector('.qv-quantity').value);
//                         let new_added_cart_qty = cart_item_qty + new_enter_qty;
//                         alert('new_qty'+ new_added_cart_qty);
//                         if(new_added_cart_qty <=5){
//                           alert('ALI');
//                           processCart()
//                         }
//                         else{
//                         	alert('more then 5');

//                         }
//                         return false;
//                       }
//                       else{
                        
//                         alert('AMEER');
                        
//                         processCart();
//                       }
//                     }
                  
//                   }
                
                  
//                 })
//                 processCart();
              }
            });
          });
         
          
//           hamza
          
        
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },
                        null,
                        "json"
                       ).done(function () {
              $('.qv-add-to-cart-response').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};
  
$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});







